<script>
  export let items;
  export let title;
  export let minWidth;

  let open = false;
  let triggerRef;
  let dropdownRef;
  let dropdownStyles = "";

  const toggleDropdown = () => {
    open = !open;

    if (open && triggerRef) {
      const rect = triggerRef.getBoundingClientRect();
      dropdownStyles = `top: ${50}px; width: ${minWidth ? `${minWidth}px` : `${rect.width}px`};`;
    }
  };

  const handleClick = (item) => {
    if (!item.disabled) {
      item.onClick();
      open = false;
    }
  };

  const handleOutsideClick = (event) => {
    if (
      open &&
      !triggerRef.contains(event.target) &&
      !dropdownRef?.contains(event.target)
    ) {
      open = false;
    }
  };

  // Attach/remove click listener when component is mounted/unmounted
  import { onMount, onDestroy } from 'svelte';
  onMount(() => {
    window.addEventListener('click', handleOutsideClick);
  });
  onDestroy(() => {
    window.removeEventListener('click', handleOutsideClick);
  });
</script>

<div class={`relative ${minWidth ? `w-[${minWidth}px]` : 'w-full'}`}>
  <button
    bind:this={triggerRef}
    on:click={toggleDropdown}
    class="btn btn-sm btn-secondary text-white items-center w-full gap-x-[6px] py-[3px] px-[12px] capitalize"
  >
    {#if open}
      <i class="fa fa-close" aria-hidden="true"></i>
      CLOSE
    {:else}
      {title}
    {/if}
  </button>
</div>

{#if open}
  <div
    bind:this={dropdownRef}
    class="absolute z-50 flex flex-col pt-1 gap-1"
    style={dropdownStyles}
  >
    {#each items as item}
      <button
        class="btn btn-sm btn-secondary text-white items-center w-full p-1 capitalize disabled:opacity-50 disabled:cursor-not-allowed text-left"
        on:click={() => handleClick(item)}
        disabled={item.disabled}
      >
        {item.label}
      </button>
    {/each}
  </div>
{/if}
